import type React from "react";
import { TextField, Typography, Box } from "@mui/material";

interface TextareaFormikProps {
  name: string;
  label: string;
  defaultValue?: string;
  value?: string;
  error: boolean;
  errorText: string;
  handleChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleBlur: (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  placeholder?: string;
  rows?: number;
  style?: React.CSSProperties;
}

export default function TextareaFormik({
  name,
  label,
  defaultValue = "",
  value,
  error,
  errorText,
  handleChange,
  handleBlur,
  placeholder,
  rows = 6,
  style = {},
}: TextareaFormikProps) {
  return (
    <Box style={style}>
      <TextField
        fullWidth
        name={name}
        label={label}
        defaultValue={defaultValue}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        variant="outlined"
        size="small"
        error={error}
        autoComplete="off"
        multiline
        rows={rows}
        placeholder={placeholder}
        helperText={placeholder && !error ? placeholder : undefined}
        FormHelperTextProps={{
          sx: { marginTop: 0.5, fontSize: "0.75rem" }
        }}
      />
      {error && (
        <Typography color="error" fontSize={12} marginTop={0.5}>
          {errorText}
        </Typography>
      )}
    </Box>
  );
}
